export const HELP_CONTENT_ALL_FIELDS = '/api/pim/qa-searchable-fields';
export const HELP_CONTENT_ADD_FIELD = '/api/pim/add-qa-spec-tooltip';
export const HELP_CONTENT_EDIT_FIELD = '/api/pim/edit-qa-spec-tooltip';
export const HELP_CONTENT_GRID_FIELDS = '/api/pim/get-qa-spec-tooltip-grid';
export const HELP_CONTENT_GET_TOOLTIP_MEMBER = '/api/pim/get-qa-spec-tooltip';
